module.exports = __webpack_public_path__ + "img/6.e659a7dc.jpg";